/* eslint-disable react-hooks/exhaustive-deps */
import { useGlobalStore } from "@/store/GlobalStore";
import { useTranslation } from "react-i18next";
import {
  DisacountText,
  Level,
  MemberCard,
  AnimationNormalRechargeWrapper,
} from "./atom";
import { UserLevel } from "project-config/constants";
import { useAnimationTopUpStore } from "../../store";
import { useEffect, useState } from "react";
import {
  ActivityRuleAndCoupon,
  AnimationCommonCardListWrapper,
  AnimationCouponCode,
} from "../../atom";
import CheckIcon from "@/assets/icons/topup/check";
import { BindActivityInfo, BindHangTags } from "@/components/top-up/types";
import { AnimationVipDesc } from "../../constants/animation-balance-info";
import { accSub } from "project-config/utils/acc";
import {
  getLotteryNumber,
  rulesContentList,
} from "@/components/top-up/help/activityUtil";
import ActivityRule from "@/components/top-up/components/activity-rule";
import LuckDrawIcon from "@/assets/icons/topup/luck-draw-icon";
import LuckDrawActiveIcon from "@/assets/icons/topup/luck-draw-active-icon";

export function AnimationNormalRecharge() {
  const { t } = useTranslation("topup");
  const { currencySymbol, userInfo, isZh, userCumulative } = useGlobalStore();
  const HangTags = useAnimationTopUpStore((state) => state.HangTags);
  const discountName = useAnimationTopUpStore((state) => state.discountName);
  const luckDrawGiftActivityInfo = useAnimationTopUpStore(
    (state) => state.luckDrawGiftActivityInfo
  );
  const lotteryActivityInfoList = useAnimationTopUpStore(
    (state) => state.lotteryActivityInfoList
  );
  const isCheckCard = useAnimationTopUpStore((state) => state.isCheckCard);
  const verifyRechargeInfo = useAnimationTopUpStore(
    (state) => state.verifyRechargeInfo
  );
  const { setter: setAnimationTopUpStore } = useAnimationTopUpStore();
  const recharge = (rechargeInfo: BindHangTags) => {
    const v = rechargeInfo.rmbCumulative;
    return Number(accSub(v, userCumulative).toFixed(2));
  };
  const [checkCardPrice, setCheckCardPrice] = useState(0);
  const [openActivityRuleDrawer, setOpenActivityRuleDrawer] = useState(false);
  const [hoverCard, setHoverCard] = useState(0);

  const getRechargeAmount = (rechargeInfo: BindHangTags) => {
    if (!userInfo) return 1;
    if (userInfo?.level === UserLevel.Diamond)
      return rechargeInfo.animationNum || 0;
    return recharge(rechargeInfo) < 0 && userInfo.level < rechargeInfo.level
      ? 1
      : recharge(rechargeInfo);
  };

  const discount = (value: number) => {
    return !isZh ? `${Number((1 - value).toFixed(2)) * 100}%` : value * 10;
  };

  const openCouponModal = () => {
    setAnimationTopUpStore((state) => {
      state.showCouponCodeModal = true;
      if (verifyRechargeInfo.couponNO) {
        state.inputCode = verifyRechargeInfo.couponNO;
      }
    });
  };

  useEffect(() => {
    if (!HangTags.length) return;
    console.log("HangTags:::", HangTags);
    const price =
      userInfo?.level === UserLevel.Diamond
        ? HangTags[0].animationNum
        : recharge(HangTags[0]);
    setCheckCardPrice(price || 0);
    setAnimationTopUpStore({
      amount: getRechargeAmount(HangTags[0]), // 防止在后管强制降低vip等级
      isCheckCard: true,
    });
  }, [HangTags]);

  return (
    <AnimationNormalRechargeWrapper>
      <ActivityRuleAndCoupon>
        {luckDrawGiftActivityInfo && (
          <ActivityRule
            ruleList={rulesContentList(
              luckDrawGiftActivityInfo as BindActivityInfo,
              isZh
            )}
            openRuleDrawer={openActivityRuleDrawer}
            changeDrawer={(val) => {
              setOpenActivityRuleDrawer(val);
            }}
            activityInfo={luckDrawGiftActivityInfo as BindActivityInfo}
          />
        )}
        <AnimationCouponCode onClick={openCouponModal}>
          {t("renderbus_recharge_redemption_code")}
        </AnimationCouponCode>
      </ActivityRuleAndCoupon>
      <AnimationCommonCardListWrapper>
        {HangTags.map((item, index) => {
          const rechargeAmount =
            userInfo?.level === UserLevel.Diamond
              ? item.animationNum
              : recharge(item);
          const lotteryNumber = luckDrawGiftActivityInfo
            ? getLotteryNumber(
                luckDrawGiftActivityInfo,
                lotteryActivityInfoList,
                rechargeAmount || 0
              )
            : 0;
          const isActive = checkCardPrice === rechargeAmount && isCheckCard;
          const isDiamond = userInfo?.level === UserLevel.Diamond;
          return (
            <MemberCard
              key={item.id}
              onClick={() => {
                setCheckCardPrice(rechargeAmount || 0);
                setAnimationTopUpStore((state) => {
                  state.amount = getRechargeAmount(item); // 防止在后管强制降低vip等级
                  state.isCheckCard = true;
                });
              }}
              onMouseEnter={() => setHoverCard(index + 1)}
              onMouseLeave={() => setHoverCard(0)}
              isActive={isActive}
              heightCard={Boolean(luckDrawGiftActivityInfo)}
              isDiamond={isDiamond}
            >
              {userInfo?.level !== UserLevel.Diamond && (
                <Level>
                  {t("upgrade_section_level")}&nbsp;
                  {t(AnimationVipDesc[item.level])}
                </Level>
              )}
              <div className="recharge-price">
                <div>
                  <span className="unit">{currencySymbol}</span>
                  <span className="price">{rechargeAmount}</span>
                </div>
                {isActive && <CheckIcon />}
              </div>
              {userInfo?.level !== UserLevel.Diamond && isZh && (
                <DisacountText>
                  <span>{t("topup_enjoy_rendering")}&nbsp;</span>
                  <span className="strong">
                    {t("upgrade_section_discount_with_rate", {
                      discount: discountName && discount(item[discountName]),
                    })}
                  </span>
                </DisacountText>
              )}
              {luckDrawGiftActivityInfo && lotteryNumber > 0 && (
                <div className="luck-draw-text">
                  {isActive || hoverCard === index + 1 ? (
                    <LuckDrawActiveIcon />
                  ) : (
                    <LuckDrawIcon />
                  )}
                  <span>
                    {t("topup_lottery_coupon")}&nbsp;{lotteryNumber}
                    {t("topup_lottery_coupon_unit")}
                  </span>
                </div>
              )}
            </MemberCard>
          );
        })}
      </AnimationCommonCardListWrapper>
    </AnimationNormalRechargeWrapper>
  );
}
